module.exports = __webpack_public_path__ + "img/face.c1c72812.svg";